import { showToast } from '../../../helpers/showToast';
import { useDidMount } from 'hooks/useDidMount';
import { Navigate, To, useLocation } from 'react-router-dom';
import React from 'react';

const NOT_FOUND_TOAST_IGNORE_LIST = [/^\/$/, /^\/null/, /^\/react/, /^\/login/, /^\/queue.*/];
export const NotFoundRedirect = ({ to }: { to: To }): JSX.Element => {
  const location = useLocation();

  useDidMount(() => () => {
    if (NOT_FOUND_TOAST_IGNORE_LIST.some(pattern => pattern.test(location.pathname))) {
      return;
    }
    showToast({
      severity: 'info',
      detail: 'Page Not Found',
      summary: '',
      sticky: false
    });
  });

  return <Navigate to={to} replace />;
};
